import React from 'react';
import classnames from 'classnames';
import './FormRadio.scss';
export const FormRadio = ({ label, isChecked, onChange, disabled, radioName, }) => (React.createElement("label", { className: classnames('form-field-radio', { disabled }) },
    label,
    React.createElement("input", { disabled: disabled, type: "radio", checked: isChecked, onChange: onChange, value: label, name: radioName }),
    React.createElement("span", { className: "form-field-radio__checkmark" })));
//# sourceMappingURL=FormRadio.js.map